<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'CandidateSearchField',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      localSearch: '',
    }
  },
  computed: {
    ...mapState('candidate', {
      candidateListSearchInput: (state) => state.candidateList.searchTerm,
    }),
    hasPendingSearch() {
      return (this.localSearch ?? '') !== (this.candidateListSearchInput ?? '')
    },
  },
  watch: {
    candidateListSearchInput(value) {
      if (value !== this.localSearch) this.localSearch = value
    },
  },
  mounted() {
    this.localSearch = this.candidateListSearchInput
  },
  methods: {
    ...mapActions('candidate', ['setCandidateListSearchTerm']),
    applySearch() {
      this.setCandidateListSearchTerm(this.localSearch ?? '')
    },
    onClear() {
      this.localSearch = ''
      this.applySearch()
    },
  },
}
</script>

<template>
  <div class="candidate-search-field mr-3">
    <v-text-field
      id="candidateSearch"
      v-model="localSearch"
      :placeholder="$t('candidateList.search.placeholder')"
      prepend-inner-icon="mdi-magnify"
      :disabled="disabled"
      clearable
      hide-details
      dense
      outlined
      @keydown.enter="applySearch"
      @click:clear="onClear"
    />

    <transition name="fade-up">
      <div v-if="hasPendingSearch" class="candidate-search-field__hint">
        {{ $t('candidateList.search.hint') }}
      </div>
    </transition>
  </div>
</template>

<style lang="scss" scoped>
@import '@/styles/_vue-transitions.scss';
@import '@/styles/_colors.scss';

.candidate-search-field {
  position: relative;
  max-width: 320px;

  ::v-deep .v-input__slot {
    border-radius: 8px;
  }

  ::v-deep fieldset {
    border-color: $color-neutral-grey-200;
  }

  &__hint {
    position: absolute;
    top: 100%;
    left: 0;
    padding: 2px 12px 0;
    font-size: 12px;
    color: rgba(0, 0, 0, 0.6);
    white-space: nowrap;
    pointer-events: none;
  }
}
</style>
